import React, { Component } from "react";
import axios from "axios";
import LocTok from "./uTk";
let failedQueue = [];
let rfAtkInit = false;
let store;



function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");
    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }
    // Return null if not found
    return null;
}
export  const axiosInterceptor=(store)=>{
axios.interceptors.request.use(
    (config) => {
        const source = axios.CancelToken.source();
        const cancelToken = source.token;
        if(!config.url.includes(".amazonaws.com")){
            config.headers["X-CSRF-TOKEN"] = getCookie('csrf_token');
        }
        if (config.url.includes("login") ||
            config.url == "/api/user/logout" ||
            config.url.includes("reset-password") ||
            config.url.includes("set-password")
            ) {
            return config;
        }
        let storedTk = new LocTok();
        if (!storedTk.isLocTokValid()) {
            storedTk.clearSession("Token not found");
            config.responseJSON = {
                message: "Request Aborted",
            };
            config.cancelToken = cancelToken;
            source.cancel("Request Canceled");
            console.log("Request Aborted");
        } else {
            storedTk.getTksFrmLoc();
            if (
                !config.url.includes("refresh") &&
                !config.url.includes("fresh-login") &&
                !config.url.includes("reset-password") &&
                !config.url.includes("set-password") &&
                !config.url.includes("logout") &&
                !config.url.includes("check_access")
            ) {
                // config.headers["Authorization"] = "Bearer " + storedTk.atk;
                // config.headers["X-CSRF-TOKEN"] = storedTk.csrf_token;
                if(config.url.includes(".amazonaws.com")){
                    if(config.url.includes(".elb.")){
                        config.headers["Authorization"] = "Bearer " + storedTk.atk;
                    }
                } else{
                    config.headers["Authorization"] = "Bearer " + storedTk.atk;
                }
            }
        }
        // config.headers['Content-Type'] = 'application/json';
        console.log(config);
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

const processFailedQueue = (error) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });
    failedQueue = [];
};

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        const originalRequest = error.config;
        const errorResponse = error.response;
        if (
            originalRequest.url.includes("login") ||
            originalRequest.url.includes("check_access") ||
            originalRequest.url == "/api/user/logout" ||
            originalRequest.url.includes("logout") ||
            originalRequest.url.includes("reset-password") ||
            originalRequest.url.includes("set-password")
        ) {
            return Promise.reject(error);
        }
        let storedTk = new LocTok();
        if (!storedTk.isLocTokValid()) {
            if (errorResponse.statusText == "Request Aborted") {
                errorResponse.data = {
                    message: errorResponse.statusText,
                };
            }
            storedTk.clearSession("Token not found");
        } else {
            storedTk.getTksFrmLoc();
            if (errorResponse.statusText == "Request Aborted") {
                errorResponse.data = {
                    message: errorResponse.statusText,
                };
            }
            let responseJSON = errorResponse.data;
            if (responseJSON) {
                switch (responseJSON.message) {
                    case "Token has expired":
                        //                          piledAccessReq.push(originalRequest);
                        if (!rfAtkInit) {
                            rfAtkInit = true;
                            let url = "/api/user/token/refresh";
                            let headers = {
                                headers: {
                                    Authorization: "Bearer " + storedTk.rtk,
                                    "X-CSRF-TOKEN": storedTk.csrf_token
                                },
                            };
                            let data = {};
                            return axios
                                .post(url, data, headers)
                                .then((response) => {
                                    response = response.data;
            
                                    let responseKeys = Object.keys(response);
                                    if (responseKeys.includes("access_token") && responseKeys.includes("refresh_token")) {
                                        console.log("ATK : REFRESHED");
                                        
                                        storedTk.updateAtkToLoc(response.access_token,response.refresh_token); 
                                      
                                            
                                        processFailedQueue(null);
                                        rfAtkInit = false;
                                        return axios(originalRequest);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                    let errorMsg = error.response.data.message;
                                    switch (errorMsg) {
                                        case "Token has expired":
                                            if (
                                                storedTk.refreshAtkAttempts <
                                                storedTk.refreshAtkAvailAttempts
                                            ) {
                                                storedTk.refreshAtkAttempts++;
                                                storedTk.refreshAtk();
                                            } else {
                                                storedTk.logout("Token not found");
                                            }
                                            break;
                                        default:
                                            if (rfAtkInit) {
                                                storedTk.logout("Token not found");
                                            } else {
                                                processFailedQueue(error);
                                                return Promise.reject(error);
                                            }
                                    }
                                });
                        } else {
                            console.log("Parallel Request when token expired");
                            let reqNotToQueue = ["/api/user/token/refresh"];
                            if (!reqNotToQueue.includes(originalRequest.url)) {
                                return new Promise(function (resolve, reject) {
                                    failedQueue.push({ resolve, reject });
                                })
                                    .then(() => {
                                        return axios(originalRequest);
                                    })
                                    .catch((error) => {
                                        return Promise.reject(error);
                                    });
                            } else {
                                return Promise.reject(error);
                            }
                        }
                    case "Logged in user not found":
                        storedTk.reloadPage();
                        return Promise.reject(error);
                    case "Session Violation. Login Again!":
                        console.log("In session violation");
                        storedTk.reloadPage();
                        return Promise.reject(error);
                    case "Session Expired. Login Again!":
                        console.log("Session Expired");
                        storedTk.reloadPage();
                        return Promise.reject(error);
                    case "The server could not verify if User is authorized, Please Re-login!":
                        console.log(
                            "The server could not verify if User is authorized, Please Re-login!"
                        );
                        storedTk.reloadPage();
                        return Promise.reject(error);
                    default:
                        console.log("In default");
                        return Promise.reject(error);
                }
            }
        }
    }
)
}


